export default (props, vars) =>
  !vars?.['defaultforeach2']?.['item']?.['disabled'];
